
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gOrBS", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $Douji = parcelRequire("Douji");

const $9591d824618efc40$var$getSharePointTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Document, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Document,
            (0, $5PPrc.NounSubtypeKey).Pdf,
            (0, $5PPrc.NounSubtypeKey).Page,
            (0, $5PPrc.NounSubtypeKey).Blogpost
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Spreadsheet, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Spreadsheet
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Presentation, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Presentation
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Video, {
        entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Video
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Image, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Image
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Folder, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Folder,
            (0, $5PPrc.NounSubtypeKey).Drive
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Pdf, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Pdf
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Notebook, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Notebook
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).WebPage, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).WebPage,
            (0, $5PPrc.NounSubtypeKey).Shortcut
        ]
    });
    config.set((0, $5PPrc.TypeFilterValueKey).Other, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Other,
            (0, $5PPrc.NounSubtypeKey).Archive
        ]
    });
    // Comments are embedded within documents as linkedEntities, not standalone entities.
    // Keep the entity type aligned to document results so any consumer of typeFilterConfig still
    // treats SharePoint comment matches as documents rather than standalone comments.
    // SharePoint embedded comments are gated behind a SharePoint-specific flag (independent of the
    // shared 3p flag used for Google Drive) so we can enable/disable SharePoint comment support
    // independently of other 3p products.
    if ((0, $iDrrr.fg)('rovo_fps_sharepoint_embedded_comments')) config.set((0, $5PPrc.TypeFilterValueKey).Comment, {
        entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
        subTypes3P: []
    });
    return config;
};
const $9591d824618efc40$export$eb46bb6c4f0e628c = {
    displayName: 'Microsoft SharePoint',
    id: 'sharepoint',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Sharepoint,
    icon: (0, $i52Hf.get3PLogo)((0, $Douji.SharePointIcon), 'Sharepoint', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $Douji.SharepointIconBorderless), 'Sharepoint', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $Douji.SharePointSearchResultIcon), 'Sharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    // Use a getter to evaluate lazily so that feature flags are evaluated when accessed, not at module load.
    get typeFilterConfig () {
        return $9591d824618efc40$var$getSharePointTypeFilterConfig();
    },
    get filters () {
        return [
            'lastUpdated',
            'onlyTitleMatch',
            'space',
            'content'
        ];
    },
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sharepointConfig"] = $9591d824618efc40$export$eb46bb6c4f0e628c;

});

parcelRegister("dAioJ", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ac1d391d64bfedde$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $ac1d391d64bfedde$export$d520529b4595d46c;

});

parcelRegister("sRb5o", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cedd31adddcd6a4e$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $cedd31adddcd6a4e$export$a3d7cddace4fe237;

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    PullRequest: 'pull-request',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $b36df32f21d2d1ae$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");


var $2sFbd = parcelRequire("2sFbd");



var $9Jc29 = parcelRequire("9Jc29");





var $Douji = parcelRequire("Douji");


var $iPmoS = parcelRequire("iPmoS");

// Legacy custom @atlaskit/icon glyphs render one size smaller than requested, so this container
// is bumped up a step to compensate (see `correctedSize` below).
const $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xlarge: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
// The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — no compensation needed.
const $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    small: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo-search-team-eu-26-brand-icon-library");
        $[0] = t1;
    } else t1 = $[0];
    const isAccurateSizeEnabled = t1;
    const t2 = isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize];
    const t3 = label || undefined;
    const t4 = label ? "img" : "presentation";
    let t5;
    if ($[1] !== SVG || $[2] !== accurateSize) {
        t5 = isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
            size: accurateSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[1] = SVG;
        $[2] = accurateSize;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            "aria-label": t3,
            role: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize })=>{
    const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: accurateSize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; // The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — unlike the legacy
// custom @atlaskit/icon glyphs above, it needs no "one size bigger" compensation.
const $8a7a1ec4b7d3b7f4$var$accurateSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize;
        const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSizeStyles[resolvedSize] : $8a7a1ec4b7d3b7f4$var$sizeStyles[$8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize]]
            ])
        }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: resolvedSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize ?? 'medium';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            legacySize: $8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize],
            accurateSize: resolvedSize
        });
    };
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $db93e344a28daeff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'small');
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'medium');
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("5mh7K", function(module, exports) {

var $6zMm4 = parcelRequire("6zMm4");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");


var $iqYgx = parcelRequire("iqYgx");


var $3Zhtx = parcelRequire("3Zhtx");

var $dZb8A = parcelRequire("dZb8A");


var $9W961 = parcelRequire("9W961");


var $f1SiZ = parcelRequire("f1SiZ");


var $6DjRB = parcelRequire("6DjRB");


var $ah4XH = parcelRequire("ah4XH");


var $cU4Ow = parcelRequire("cU4Ow");


var $31PDK = parcelRequire("31PDK");


function $bfc96ad9243c26fc$var$noop() {}
function $bfc96ad9243c26fc$var$deferToPhase(phase) {
    switch(phase){
        case (0, $iqYgx.PHASE).PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $iqYgx.PHASE).AFTER_PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-visible'
            });
        case (0, $iqYgx.PHASE).LAZY:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $bfc96ad9243c26fc$var$lazyProxy(loader, { defer: defer = (0, $iqYgx.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $3Zhtx.isNodeEnvironment)();
    const dataLazyId = (0, $dZb8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const LazyInternal = isServer ? (0, $f1SiZ.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $9W961.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ah4XH.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$bfc96ad9243c26fc$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $31PDK.retry)(deferredLoader, {
                    delay: (0, $6DjRB.RETRY_DELAY),
                    factor: (0, $6DjRB.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $3Zhtx.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jrpaf.getConfig)();
        return (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $iqYgx.PHASE).PAINT ? (0, $6DjRB.PRIORITY).HIGH : (0, $6DjRB.PRIORITY).LOW);
        return (0, $cU4Ow.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $bfc96ad9243c26fc$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $iqYgx.PHASE).LAZY
    }
};
function $bfc96ad9243c26fc$export$c952e5f94576010e(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$291dd592399bdafa(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$488013bae63b21da(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $bfc96ad9243c26fc$export$c952e5f94576010e;
module.exports["lazy"] = $bfc96ad9243c26fc$export$488013bae63b21da;

});

parcelRegister("3zIme", function(module, exports) {
const $26c544e248d4f3ef$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $26c544e248d4f3ef$export$303f43e55cf1ef2f;

});

parcelRegister("jrpaf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("hwBK6")).MODE);

var $hwBK6 = parcelRequire("hwBK6");

const $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8f2b5a3b1d08430b$var$DEFAULT_MODE = (0, $hwBK6.MODE).HYDRATE;
const $8f2b5a3b1d08430b$var$DEFAULT_RETRY = 2;
const $8f2b5a3b1d08430b$var$nullFunction = ()=>{};
const $8f2b5a3b1d08430b$var$config = {
    crossOrigin: $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST,
    mode: $8f2b5a3b1d08430b$var$DEFAULT_MODE,
    retry: $8f2b5a3b1d08430b$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $8f2b5a3b1d08430b$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $8f2b5a3b1d08430b$export$44487a86467333c3 = ()=>$8f2b5a3b1d08430b$var$config;
const $8f2b5a3b1d08430b$export$940a7873bb071df8 = (nextConfig)=>{
    $8f2b5a3b1d08430b$var$config.crossOrigin = nextConfig.crossOrigin ?? $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN;
    $8f2b5a3b1d08430b$var$config.manifest = nextConfig.manifest ?? $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST;
    $8f2b5a3b1d08430b$var$config.mode = nextConfig.mode ?? $8f2b5a3b1d08430b$var$DEFAULT_MODE;
    $8f2b5a3b1d08430b$var$config.retry = nextConfig.retry ?? $8f2b5a3b1d08430b$var$DEFAULT_RETRY;
    $8f2b5a3b1d08430b$var$config.react18 = nextConfig.react18 ?? false;
    $8f2b5a3b1d08430b$var$config.onChunkRender = nextConfig.onChunkRender ?? $8f2b5a3b1d08430b$var$nullFunction;
    $8f2b5a3b1d08430b$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $8f2b5a3b1d08430b$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $8f2b5a3b1d08430b$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $8f2b5a3b1d08430b$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $8f2b5a3b1d08430b$export$44487a86467333c3;

});

parcelRegister("hwBK6", function(module, exports) {
const $b5e78af7707a7c4f$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $b5e78af7707a7c4f$export$e48589d9e4824227;

});

parcelRegister("iqYgx", function(module, exports) {
const $affaceaac00ccc54$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $affaceaac00ccc54$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $affaceaac00ccc54$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $affaceaac00ccc54$export$4831ef3968ea94ef;

});

parcelRegister("3Zhtx", function(module, exports) {

var $dZb8A = parcelRequire("dZb8A");

const $a3803c67f4544810$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a3803c67f4544810$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a3803c67f4544810$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a3803c67f4544810$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a3803c67f4544810$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a3803c67f4544810$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a3803c67f4544810$export$283635c04a02cc36;
module.exports["attrToProp"] = $a3803c67f4544810$export$62bf630d0de3d781;

});

parcelRegister("dZb8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2d13c19047c2e6$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2a2d13c19047c2e6$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9W961", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $6pwcu = parcelRequire("6pwcu");


var $hGTvt = parcelRequire("hGTvt");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");


var $27xqQ = parcelRequire("27xqQ");


var $bYDpj = parcelRequire("bYDpj");


var $iQUPl = parcelRequire("iQUPl");


var $6mYYR = parcelRequire("6mYYR");


var $ipkS0 = parcelRequire("ipkS0");

function $9e10a968465c2ceb$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-5jsj4G", ()=>deferred.promise, {
        renderTime: true,
        source: "platform/packages/async/react-loosely-lazy/src/lazy/components/client.tsx:34"
    }));
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const profiler = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $27xqQ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $cozmU.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $6mYYR.useSubscription)({
                context: (0, $6pwcu.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $iqYgx.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $6mYYR.useSubscription)({
                context: (0, $hGTvt.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $cozmU.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $iqYgx.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iQUPl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bYDpj.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $cozmU.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $jrpaf.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $hwBK6.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $9e10a968465c2ceb$export$6898b5504b58699a;

});

parcelRegister("6pwcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aJQSl = parcelRequire("aJQSl");

const $548763ff32fd4fa9$export$9ba3fe09d15de47b = (0, $cozmU.createContext)({
    subscribe: ()=>(0, $aJQSl.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $548763ff32fd4fa9$export$9ba3fe09d15de47b;

});

parcelRegister("aJQSl", function(module, exports) {
const $05617924a76d0a6c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $05617924a76d0a6c$export$276c7dbda7675aec;

});

parcelRegister("hGTvt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqYgx = parcelRequire("iqYgx");


var $lJvTv = parcelRequire("lJvTv");


var $dcIK9 = parcelRequire("dcIK9");

let $672f0e6595584070$var$CURRENT_PHASE = (0, $iqYgx.PHASE).PAINT;
const $672f0e6595584070$export$5f80f094fd31fffd = (phase)=>{
    $672f0e6595584070$var$CURRENT_PHASE = phase;
    (0, $lJvTv.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $672f0e6595584070$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $dcIK9.createSubscribe)((0, $lJvTv.LISTENERS)),
    currentValue: ()=>$672f0e6595584070$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).PAINT)
    }
});
const $672f0e6595584070$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($672f0e6595584070$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $672f0e6595584070$export$5a25eca35e5debcb;

});

parcelRegister("lJvTv", function(module, exports) {
const $17f151a063744015$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $17f151a063744015$export$81b9c458a026d68f;

});

parcelRegister("dcIK9", function(module, exports) {
const $66c4eef17986e77d$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $66c4eef17986e77d$export$364097d812234b3f;

});

parcelRegister("bSocS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b79a9622223785f$export$e2d53c0cbedd2710 = {
    current: null
};
const $0b79a9622223785f$export$8146ab57a3f7a7cb = (0, $cozmU.createContext)($0b79a9622223785f$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $0b79a9622223785f$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $0b79a9622223785f$export$8146ab57a3f7a7cb;

});

parcelRegister("3UFgg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");

const $307cdf761723c83f$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {}),
    setFallback: ()=>{
        if ((0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $307cdf761723c83f$export$c33990e84065970c;

});

parcelRegister("27xqQ", function(module, exports) {
const $8d723af0e292a27d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $8d723af0e292a27d$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$8d723af0e292a27d$export$6aa69c1258005366]: true
    });
    return error;
};
const $8d723af0e292a27d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8d723af0e292a27d$export$6aa69c1258005366);
module.exports["createLoaderError"] = $8d723af0e292a27d$export$c73a6a6f0bf7d425;

});

parcelRegister("bYDpj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3Zhtx = parcelRequire("3Zhtx");

const $308221388927349f$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $3Zhtx.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $308221388927349f$export$ca5b8fbc835d95e4;

});

parcelRegister("iQUPl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6pwcu = parcelRequire("6pwcu");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");

function $fac82888d07c9621$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $fac82888d07c9621$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    const profilerContext = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
    const waitContext = (0, $cozmU.useContext)((0, $6pwcu.WaitContext));
    const suspenseContext = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($fac82888d07c9621$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $fac82888d07c9621$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $fac82888d07c9621$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $fac82888d07c9621$export$d55db778a3e1446b;

});

parcelRegister("6mYYR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fb43d3d8deaa2f13$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $fb43d3d8deaa2f13$export$368b4214baeb914c;

});

parcelRegister("f1SiZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $3UFgg = parcelRequire("3UFgg");


var $3Zhtx = parcelRequire("3Zhtx");


var $27xqQ = parcelRequire("27xqQ");

function $e4910f9bc5a8efc5$var$load(moduleId, loader) {
    try {
        return (0, $3Zhtx.getExport)(loader());
    } catch (err) {
        throw (0, $27xqQ.createLoaderError)(err);
    }
}
function $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $jrpaf.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e4910f9bc5a8efc5$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $hwBK6.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $iqYgx.PHASE).LAZY && (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("link", {
                        rel: defer === (0, $iqYgx.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e;

});

parcelRegister("6DjRB", function(module, exports) {
const $ee7f0d866347d691$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ee7f0d866347d691$export$a339266ad71b2447 = 300;
const $ee7f0d866347d691$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $ee7f0d866347d691$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $ee7f0d866347d691$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $ee7f0d866347d691$export$ba64c908e55507fe;

});

parcelRegister("ah4XH", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $841e841717fb4840$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $841e841717fb4840$var$preloadIds;
const $841e841717fb4840$export$ac21d099cbc8d569 = (preload)=>{
    $841e841717fb4840$var$preloadIds = preload;
    try {
        $841e841717fb4840$var$preloadIds.forEach((lazyId)=>{
            const deffered = $841e841717fb4840$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $841e841717fb4840$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $841e841717fb4840$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($841e841717fb4840$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $841e841717fb4840$export$e673efccd97e4223;

});

parcelRegister("cU4Ow", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");


var $3Zhtx = parcelRequire("3Zhtx");


var $6DjRB = parcelRequire("6DjRB");


var $1Y0Bp = parcelRequire("1Y0Bp");

function $72b45db42b4960fa$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jrpaf.getConfig)();
    const assets = (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1Y0Bp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $72b45db42b4960fa$var$fakePromise = {
    then: ()=>$72b45db42b4960fa$var$fakePromise,
    catch: ()=>$72b45db42b4960fa$var$fakePromise,
    finally: ()=>$72b45db42b4960fa$var$fakePromise
};
function $72b45db42b4960fa$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1Y0Bp.insertLinkTag)(href, rel));
        return $72b45db42b4960fa$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $72b45db42b4960fa$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $aJQSl.noopCleanup;
}
function $72b45db42b4960fa$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $3Zhtx.isNodeEnvironment)()) return 0, $aJQSl.noopCleanup;
    (0, $bSocS.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $6DjRB.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $72b45db42b4960fa$export$3af04dbcb01bad4d,
        $72b45db42b4960fa$export$1046fd6a49d5e7a,
        $72b45db42b4960fa$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $aJQSl.noopCleanup;
}
module.exports["preloadAsset"] = $72b45db42b4960fa$export$25bad4aa00c45355;

});

parcelRegister("1Y0Bp", function(module, exports) {

var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");

function $e5a7bcb8f7812549$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $aJQSl.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jrpaf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bSocS.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $e5a7bcb8f7812549$export$6610512821c8a4ce;

});

parcelRegister("31PDK", function(module, exports) {
const $e0741a36efbb4dfa$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e0741a36efbb4dfa$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e0741a36efbb4dfa$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $e0741a36efbb4dfa$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e0741a36efbb4dfa$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e0741a36efbb4dfa$var$calculateDelay(context, policy);
        if (delay) await $e0741a36efbb4dfa$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $e0741a36efbb4dfa$export$9369b12211e1fce4;

});

parcelRegister("3LxIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $1efef99f0e02a868$export$7c51f1b21238e429(LegacyIcon, OfficialIcon, defaultSize) {
    return function BrandIcon({ size: size = defaultSize } = {}) {
        if ((0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OfficialIcon, {
            label: "",
            size: size
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LegacyIcon, null);
    };
}
module.exports["withBrandIcon"] = $1efef99f0e02a868$export$7c51f1b21238e429;

});

parcelRegister("4hzFj", function(module, exports) {

let $31e46a58d87c0f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31e46a58d87c0f49$var$load("jxGqt").then(()=>parcelRequire('fyTd1'));

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6ce68911b0df4e15$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'small');
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'medium');
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'xxsmall');
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("9dtYX", function(module, exports) {

let $6b5c95c494a16587$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b5c95c494a16587$var$load("4LY4N").then(()=>parcelRequire('kmcLM'));

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2cad9d35507cac43$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("enDSk")).then((m)=>m.MicrosoftAzureDevOpsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-azure-devops'
});

const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'small');
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'medium');
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("enDSk", function(module, exports) {

let $a782250e15e8574e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a782250e15e8574e$var$load("jLsGY").then(()=>parcelRequire('b9s7D'));

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("2sFbd", function(module, exports) {
/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $809b94d6e1c8821b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ln0Jc")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/logo-third-party/slack'
});

// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'small');
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'medium');
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("ln0Jc", function(module, exports) {

let $f8ec4f8a6e6abecf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8ec4f8a6e6abecf$var$load("7S2Sh").then(()=>parcelRequire('eaD9b'));

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("9Jc29", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f96caf77f5e0e90e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $f96caf77f5e0e90e$export$e16bd899bb4eebf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'small');
const $f96caf77f5e0e90e$export$99050685a064f8e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'medium');
const $f96caf77f5e0e90e$export$1f3b452b60b13122 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
const $f96caf77f5e0e90e$export$e087ba40596ff085 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
module.exports["GoogleDriveIcon"] = $f96caf77f5e0e90e$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $f96caf77f5e0e90e$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $f96caf77f5e0e90e$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $f96caf77f5e0e90e$export$e087ba40596ff085;

});

parcelRegister("hcdgm", function(module, exports) {

let $c84dd866b614e7fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c84dd866b614e7fc$var$load("iDrFi").then(()=>parcelRequire('4zc1o'));

});

parcelRegister("eauWV", function(module, exports) {

let $a50a01c0fe4d8419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a50a01c0fe4d8419$var$load("fz4Mg").then(()=>parcelRequire('aqriX'));

});

parcelRegister("Douji", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $216cd14c42636556$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'small');
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'medium');
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null)), $216cd14c42636556$var$OfficialIcon, 'xxsmall');
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("60nw9", function(module, exports) {

let $45f4fc3fccb59bad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45f4fc3fccb59bad$var$load("i8lZ0").then(()=>parcelRequire('8RTwe'));

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("iPmoS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b77f1e6828d0ac82$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'small');
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});


//# sourceMappingURL=sharepoint.2b4de4d1.js.map
